export default __webpack_public_path__ + "static/media/33.1b38f0fc.svg";